import { Survey } from './survey';

export class SurveyLink {

  id: number;
  key: string;
  tag: string;
  survey_id: number;
  type: string;
  is_private: boolean;

  created: string;
  activated: string;
  deactivated: string;
  deleted: string;

  // fixme what type here?
  metadata: any;
  responses: number;
  is_active: boolean;

  private _survey: Survey;

  getSurvey(): Survey {
    return this._survey;
  }

  setSurvey(survey: Survey) {
    this._survey = survey;
  }

  // not self.activated is None and self.deactivated is None
  isActive(): boolean {
    if (this.activated !== undefined && this.deactivated === undefined)
      return true;
    return false;
  }

  toJSON(): Object {
    // create an instance of the SurveyLink class
    let survey_link = Object.create(SurveyLink.prototype);
    // copy all the fields from the json object
    survey_link.key = this.key;
    survey_link.tag = this.tag;
    survey_link.type = this.type;
    survey_link.is_private = this.is_private;

    return survey_link;
  }

  static fromJSON(survey_link_json: any): SurveyLink {

    // create an instance of the SurveyLink class
    let surveyLink = Object.create(SurveyLink.prototype);
    // copy all the fields from the json object
    let obj = Object.assign(surveyLink, survey_link_json, {
      // fixme this conversion block may even be not used!
      // convert fields that need converting
      //created: new Date(survey_link_json.created),
      //activated: new Date(survey_link_json.activated),
      //deactivated: new Date(survey_link_json.deactivated),
      //deleted: new Date(survey_link_json.deleted),

    });
    return surveyLink;

  }
}

